import type { WallShape } from '@walls/store';
import { hexToRgba } from '../utils/color';
import { getRectangleAttributes } from '../utils/shapeAttributes';
import { drawSelectionBorder } from './drawSelectionBorder';

export function drawRectangle(
  context: CanvasRenderingContext2D,
  shape: WallShape,
  zoom: number,
  selected: boolean
) {
  const attributes = getRectangleAttributes(shape);

  context.setLineDash([0]);
  context.beginPath();
  context.rect(attributes.x, attributes.y, attributes.width, attributes.height);

  if (attributes.fillColor) {
    context.fillStyle = hexToRgba(attributes.fillColor, attributes.fillOpacity);
    context.fill();
  }

  context.lineWidth = attributes.lineThickness;
  context.strokeStyle = hexToRgba(attributes.lineColor, attributes.lineOpacity);
  context.stroke();

  if (selected) {
    drawSelectionBorder(context, attributes, zoom);
  }
}
